import { Badge } from '@/components/ui';
import type { IBimRelationshipGraph } from '@skystone/shared';

export interface BimGraphToolbarProps {
  graph: IBimRelationshipGraph | null;
  tableCount: number;
  edgeCount: number;
  search: string;
  includeInactive: boolean;
  onlyOneToMany: boolean;
  showLabels: boolean;
  hasSelection: boolean;
  onSearchChange: (value: string) => void;
  onIncludeInactiveChange: (value: boolean) => void;
  onOnlyOneToManyChange: (value: boolean) => void;
  onShowLabelsChange: (value: boolean) => void;
  onClearSelection: () => void;
}

export function BimGraphToolbar(props: BimGraphToolbarProps) {
  const {
    graph,
    tableCount,
    edgeCount,
    search,
    includeInactive,
    onlyOneToMany,
    showLabels,
    hasSelection,
    onSearchChange,
    onIncludeInactiveChange,
    onOnlyOneToManyChange,
    onShowLabelsChange,
    onClearSelection,
  } = props;

  return (
    <div className="rounded-md border border-border bg-card p-4">
      <div className="flex flex-wrap items-center gap-4 text-sm">
        <Badge variant="secondary">Tables: {tableCount}</Badge>
        <Badge variant="secondary">Relationships: {edgeCount}</Badge>
        <Badge variant="secondary">Total in BIM: {graph?.totalRelationships ?? 0}</Badge>
        <Badge variant="warning">Excluded LocalDate: {graph?.excludedLocalDateRelationships ?? 0}</Badge>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-3">
        <input
          type="text"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Search table or key column..."
          className="h-10 rounded-md border border-input bg-background px-3 text-sm"
        />
        <label className="flex items-center gap-2 text-sm text-muted-foreground">
          <input
            type="checkbox"
            checked={includeInactive}
            onChange={(event) => onIncludeInactiveChange(event.target.checked)}
            className="h-4 w-4 rounded border-input accent-primary"
          />
          <span>Show inactive relationships</span>
        </label>
        <label className="flex items-center gap-2 text-sm text-muted-foreground">
          <input
            type="checkbox"
            checked={onlyOneToMany}
            onChange={(event) => onOnlyOneToManyChange(event.target.checked)}
            className="h-4 w-4 rounded border-input accent-primary"
          />
          <span>Show only 1:* relationships</span>
        </label>
        <label className="flex items-center gap-2 text-sm text-muted-foreground md:col-span-2">
          <input
            type="checkbox"
            checked={showLabels}
            onChange={(event) => onShowLabelsChange(event.target.checked)}
            className="h-4 w-4 rounded border-input accent-primary"
          />
          <span>Show all edge labels (can be crowded)</span>
        </label>
        {hasSelection && (
          <button
            type="button"
            onClick={onClearSelection}
            className="h-9 rounded-md border border-input px-3 text-sm text-foreground hover:bg-muted"
          >
            Reset highlight
          </button>
        )}
      </div>
    </div>
  );
}
